import { Component } from '@theme/component';

  if (!customElements.get('bunique-look-hotspots')) {
    customElements.define('bunique-look-hotspots', class extends Component {
      connectedCallback() {
        super.connectedCallback();
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const trigger = event.target.closest('.bunique-hotspot__trigger');
          if (trigger) {
            const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
            this.close();
            if (!wasOpen) {
              this.activeTrigger = trigger;
              trigger.setAttribute('aria-expanded', 'true');
              const panel = this.querySelector('#' + CSS.escape(trigger.getAttribute('aria-controls')));
              panel.hidden = false;
            }
          } else if (event.target.closest('.bunique-hotspot__close')) {
            this.close(true);
          }
        }, options);
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.close();
          else if (!event.target.closest('.bunique-hotspot__point')) this.close();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.activeTrigger) {
            event.preventDefault();
            this.close(true);
          }
        }, options);
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.close();
        }, options);
      }
      close(restoreFocus = false) {
        const trigger = this.activeTrigger;
        this.querySelectorAll('.bunique-hotspot__card').forEach(panel => { panel.hidden = true; });
        this.querySelectorAll('.bunique-hotspot__trigger').forEach(button => button.setAttribute('aria-expanded', 'false'));
        this.activeTrigger = null;
        if (restoreFocus && trigger) trigger.focus();
      }
      disconnectedCallback() {
        super.disconnectedCallback();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
